import http from "@/http";

const ClienteRuralService = {
  async buscarClientesRurais(filtro = {}, pagina = 1, itensPorPagina = 10) {
    try {
      const params = {
        ...filtro,
        page: pagina,
        per_page: itensPorPagina
      };
      const response = await http.post(
        "/api/astec/getClienteRuralLista",
        params
      );
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar clientes rurais:", error);
      throw error;
    }
  }
};

export default ClienteRuralService;
